<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.formulaPlan") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/formulaPlan">
              <span>{{$t('tlt.formulaPlan')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('formulaPlan')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div>
    </div>
     <section class="app-content">
      <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form>
                                <mes-filter entity="formulaPlan" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

      <div id="formulaPlanResultTable" class="content">
        <div class="card my-1">
          <div class="card-header"><h6>{{ $t("tlt.formulaPlanInfo") }}</h6></div>
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="formulaPlan" inline-actions-disabled singleChoice halfHeight>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
      <div id="formulaPlanDetailsResultTable" class="content">
        <div class="card my-1">
          <div class="card-header"><h6>{{ $t("tlt.formulaPlaDetial") }}</h6></div>
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="formulaPlanDetails" 
              disableDelete 
              disableEdit
              disableInlineDelete
              disableInlineView
              singleChoice 
              halfHeight 
              :isUsingCustomMethod="true" formulaDetailSave="formulaDetailSave">
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/inventoryMgt/FormulaPlan";
import { gridFields } from "@/model/prd/inventoryMgt/FormulaPlanDetails";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";
import MesFilter from '@/components/MesFilter'
import _ from "lodash";

const moduleName = "formulaPlan";
// create a helper to generate getters and setters with namespace

const { mapFields } = createHelpers({
  getterType: "formulaPlan/getField",
  mutationType: "formulaPlan/updateField"
});
// const { subMapFields } = createHelpers({
//   getterType: "formulaPlanDetails/getField",
//   mutationType: "formulaPlanDetails/updateField"
// });
export default {
  name: "formulaPlanList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker,MesFilter },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(filterFields),
    // ...subMapFields({
    //   'planCodeFilter':'filter.planCodeFilter'
    // }),

    ...mapState({
      rows: state => state.formulaPlan.rows,
      tableColumns: gridFields,
      entity: state => state.formulaPlan.entity,
      // entity1: state => state.formulaPlanDetails.entity
      checkedItems: state => state.formulaPlan.checkedItems,
      rows: state => state.formulaPlan.rows,
    })
  },
  
  methods: {
    ...mapActions("formulaPlan", ["formulaPlanNew", "View"]),
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter","MMFNew"]),
    ...mapMutations("formulaPlanDetails", ["setRows"]),
    ...mapActions("formulaPlanDetails", ["getDetails"]),
    ...mapActions(moduleName, ["jumpToEdit"]),
    // 等待请求时动画
    waitingCallback() {},
    // 触发请求
    formulaDetailSave(entity){
      this.$store.dispatch('formulaPlanDetails/Save',entity);
    }
    
  },
  addRow() {
            var newRow =  model[this.attributeEntity].newEntity();
            newRow.rowState.inEditMode = true
            newRow.rowState["tempId"] = this.tempId
            this.tempId = this.tempId - 1
            this.$store.commit(this.entity + "/addAttributeRow", {entityAttributeKey: this.attributeKey, row: newRow});
        },
  mounted() {},
  watch: {
    checkedItems(newIdList) {
      if (newIdList.length > 0) {
        this.waitingCallback();
        let id = newIdList[0]
        let item = this.rows.filter(v=>v.id === id)[0]
        // this.planCodeFilter = item.planCode;
        this.getDetails(item.planCode);
      }else{
        this.setRows([]); // 清空
      }
    }
  }
};
</script>
